"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLoading = _interopRequireDefault(require("react-loading"));

var _emotionTheming = require("emotion-theming");

var _objectPath = require("object-path");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.constants"));

var _Button = require("./Button.styles");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = function Button(_ref) {
  var style = _ref.style,
      children = _ref.children,
      disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      onClick = _ref.onClick,
      className = _ref.className,
      block = _ref.block,
      color = _ref.color,
      styles = _ref.styles,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      variant = _ref.variant,
      textColor = _ref.textColor,
      onKeyPress = _ref.onKeyPress,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      tabIndex = _ref.tabIndex,
      type = _ref.type,
      form = _ref.form;
  var theme = (0, _emotionTheming.useTheme)();

  var getRootStyle = function getRootStyle() {
    if (style) return style;

    if (Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
      if ((0, _objectPath.has)(styles, 'root')) return styles.root(theme);
    }

    return undefined;
  };

  var getLoadingStyle = function getLoadingStyle() {
    if (Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
      if ((0, _objectPath.has)(styles, 'loading')) return styles.loading(theme);

      if (variant === 'outlined' || variant === 'reversed') {
        return (0, _Button.getButtonText)({
          theme: theme,
          color: color
        });
      }

      return (0, _Button.getButtonText)({
        theme: theme,
        color: textColor
      });
    }

    return variant === 'outlined' || variant === 'reversed' ? _eyemobileCore["default"]["default"] : 'white';
  };

  var getIconStyle = function getIconStyle() {
    if (Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
      if ((0, _objectPath.has)(styles, 'icon')) return styles.icon(theme);
    }

    return undefined;
  };

  var renderStartIcon = function renderStartIcon() {
    if (!startIcon) return null;

    var clonedStartIcon = /*#__PURE__*/_react["default"].cloneElement(startIcon, {
      style: getIconStyle()
    });

    return (0, _core.jsx)("span", {
      css: _Button.startIconWrapper
    }, clonedStartIcon);
  };

  var renderEndIcon = function renderEndIcon() {
    if (!endIcon) return null;

    var clonedEndIcon = /*#__PURE__*/_react["default"].cloneElement(endIcon, {
      style: getIconStyle()
    });

    return (0, _core.jsx)("span", {
      css: _Button.endIconWrapper
    }, clonedEndIcon);
  };

  return (0, _core.jsx)(_Button.StyledButton, {
    style: getRootStyle(),
    disabled: disabled,
    onClick: onClick,
    type: type,
    className: className,
    color: color,
    textColor: textColor,
    block: block,
    variant: variant,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onKeyPress: onKeyPress,
    tabIndex: tabIndex,
    form: form
  }, renderStartIcon(), children, renderEndIcon(), isLoading && (0, _core.jsx)("div", {
    css: _Button.loadingClassName
  }, (0, _core.jsx)(_reactLoading["default"], {
    type: "spin",
    height: 20,
    width: 20,
    color: getLoadingStyle()
  })));
};

Button.defaultProps = {
  block: false,
  disabled: false,
  isLoading: false,
  className: undefined,
  color: 'button',
  textColor: 'buttonText',
  style: undefined,
  styles: undefined,
  startIcon: undefined,
  endIcon: undefined,
  variant: 'default',
  onClick: undefined,
  onKeyPress: undefined,
  onKeyUp: undefined,
  onKeyDown: undefined,
  tabIndex: undefined,
  type: 'button',
  form: undefined
};
Button.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].func, _propTypes["default"].string]).isRequired,
  block: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  style: _propTypes["default"].object,
  styles: _propTypes["default"].shape({
    root: _propTypes["default"].func,
    loading: _propTypes["default"].func,
    icon: _propTypes["default"].func
  }),
  startIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  endIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  variant: _propTypes["default"].string,
  tabIndex: _propTypes["default"].number,
  type: _propTypes["default"].string,
  form: _propTypes["default"].string
};
var _default = Button;
exports["default"] = _default;

//# sourceMappingURL=Button.js.map